<template>
  <div>
    <template v-if="['Super Admin','admin', 'internal', 'pelaksana-suban','external'].includes(cookiesJenisAkun)">
      <b-card no-body class="mb-1">
        <b-card-header class="px-2 text-uppercase">
          <h4 class="font-weight-bold text-uppercase">
            Filters & Pencarian
          </h4>
        </b-card-header>
        <b-card-body>
          <validation-observer ref="simpleRules">
            <b-row>
              <b-col cols="12" md="3" lg="3">
                <validation-provider #default="{ errors }" name="Tahun Pelaksanaan" rules="">
                  <b-form-group label="Tahun Pelaksanaan" label-for="tahunFilter">
                    <b-form-select id="tahunFilter" v-model="formFilter.tahun" :options="dsTahunPelaksanaan" disabled />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="4" lg="4">
                <validation-provider #default="{ errors }" name="Wilayah" rules="">
                  <b-form-group label="Wilayah" label-for="wilayahFilter">
                    <b-overlay :show="isLoadWilayah" variant="light" opacity="0.85" blur="2px" rounded="sm">
                      <b-form-select id="wilayahFilter" v-model="formFilter.wilayah" :options="dsWilayah"
                        @change="changeWilayah" />
                    </b-overlay>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12" md="5" lg="5">
                <validation-provider #default="{ errors }" name="PD/UKPD/UPB" rules="">
                  <b-form-group label="PD/UKPD/UPB" label-for="kolokFilter">
                    <b-overlay :show="isLoadKolok" variant="light" opacity="0.85" blur="2px" rounded="sm">
                      <v-select id="kolokFilter" v-model="formFilter.kolok" label="text" :options="dsKolok" />
                    </b-overlay>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
          </validation-observer>
          <b-row>
            <b-col cols="12" class="d-flex justify-content-end">
              <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="md" @click="submitFilter">
                <feather-icon icon="SearchIcon" class="mr-1" />Cari
              </b-button>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </template>
    <div v-if="stateEvent == 'detail'" ref="formDaftarBmdRef">
      <Detail :parent-filter="filterValue" :fd="formDatas" @changeStateEvent="handleStateEvent" />
    </div>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BButton,
  BFormGroup,
  BFormSelect,
  BSpinner,
} from "bootstrap-vue";
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import moment from 'moment'
import { generateYears, startYear } from "@/libs/helper";
import masterBRef from "@/composables/master/masterBRef";
import vSelect from "vue-select";

import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { temp } from "@/@core/directives/animations";
import Detail from "./form/Detail"

export default {
  setup(props, context) {
    const g = context.root;
    const $route = g.$route;
    const cookiesJenisAkun = ref(g.$cookies.get("jenisAkun"));
    const year = g.$cookies.get("tahun") || moment().format('YYYY');
    const formFilter = ref({
      tahun: year,
      wilayah: ['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun")) ? g.$cookies.get('wilayah') : '',
      kolok: 'semua'
    });
    const filterValue = ref({
      tahun: year,
      wilayah: ['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun")) ? g.$cookies.get('wilayah') : '',
      kolok: ['A', 'D', 'F'].includes(g.$cookies.get("jenisAkun")) ? g.$cookies.get('kolok') : 'semua'
    });

    const stateEvent = ref('detail');
    const stateTemplate = ref('pd');
    const formDatas = ref({});
    /* Dataset */
    let tempListYear = [{
      text: '--Pilih Salah Satu--',
      value: '',
    }]
    if (g.$cookies.get('listTahun')) {
      const listTahun = JSON.parse(g.$cookies.get('listTahun'))
      tempListYear = [...tempListYear, ...listTahun.map(item => ({ ...item, value: item.tahun_pelaksanaan, text: item.tahun_pelaksanaan }))]
      filterValue.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value
      formFilter.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value
    } else {
      tempListYear = [...tempListYear, ...generateYears(startYear, year)]
      filterValue.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value
      formFilter.value.tahun = $route.query.tahun || tempListYear[tempListYear.length - 1].value
    }
    const dsTahunPelaksanaan = ref(tempListYear)
    const isLoadWilayah = ref(false);
    const dsWilayah = ref([]);
    const getDsWilayah = () => {
      isLoadWilayah.value = true;
      dsWilayah.value = [];
      masterBRef.getWilayah(g).then(res => {
        if (res.success) {
          res.rows.unshift({ text: '-- Semua --', value: '' })
          dsWilayah.value = res.rows;
        }
        isLoadWilayah.value = false;
      }).catch(err => {
        isLoadWilayah.value = false;
        dsWilayah.value = [];
        console.log(err)
      });
    };
    getDsWilayah();
    /* --------- */
    const isLoadKolok = ref(false);
    const dsKolok = ref([]);
    const getDsKolok = (searchKolok = "") => {
      dsKolok.value = [];
      isLoadKolok.value = true;
      let params = {
        tahun: formFilter.value.tahun,
        wilayah: formFilter.value.wilayah,
        cari: searchKolok,
      };
      masterBRef.getKolokDs(g, params).then(res => {
        if (res.success) {
          res.rows.unshift({ text: '-- Semua --', value: '' })
          dsKolok.value = res.rows;
        }
        formFilter.value.kolok = (dsKolok.value) ? dsKolok.value?.[0] : 'semua'
        isLoadKolok.value = false;
      }).catch(err => {
        dsKolok.value = [];
        isLoadKolok.value = false;
        console.log(err)
      });
    };
    getDsKolok();

    /* Handler Function */
    const formDaftarBmdRef = ref(null);
    const handleStateEvent = (event) => {
      stateEvent.value = event;
      formDaftarBmdRef.value.scrollIntoView({ behavior: 'smooth' });
    }

    const submitFilter = () => {
      context.refs.simpleRules.validate().then(success => {
        if (success) {
          filterValue.value.tahun = formFilter.value.tahun;
          filterValue.value.wilayah = formFilter.value.wilayah;
          filterValue.value.kolok = (formFilter.value.kolok) ? formFilter.value.kolok.value : 'semua';
          handleStateEvent('detail');
        }
      });
    };

    const searchPdUpd = async search => {
      getDsKolok(search);
    }

    const changeWilayah = () => {
      formFilter.value.kolok = null;
      getDsKolok()
    }

    /* On Mounted */
    /* ------------------------------- */

    /* Download Upload Dokumen SK Tim */
    const loadingCetak = ref(false);
    const cetakDokumenSkTim = () => {
      loadingCetak.value = true;
      setTimeout(() => {
        loadingCetak.value = false;
      }, 2000);
    }
    return {
      isLoadWilayah,
      isLoadKolok,
      formFilter,
      filterValue,
      dsTahunPelaksanaan,
      dsWilayah,
      dsKolok,
      submitFilter,
      searchPdUpd,
      changeWilayah,
      /////////////////

      formDaftarBmdRef,
      stateTemplate,
      cookiesJenisAkun,

      stateEvent,
      formDatas,
      handleStateEvent,

      loadingCetak,
      cetakDokumenSkTim
    };
  },
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    BFormGroup,
    BFormSelect,
    BButton,
    BSpinner,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    Detail
  },
  data() {
    return {
      required
    };
  },

  methods: {

  },
  directives: {
    Ripple,
  },
  props: {
    page: String,
  },
};
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>